import { Stack, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'

interface CourtCaseProps {
  number: number
  item: any
}

export default function CourtCase({ number, item }: CourtCaseProps) {
  const theme = useTheme()

  const fields = [
    { label: '案号', value: item?.caseCode },
    { label: '案件类型', value: item?.caseType },
    { label: '诉讼地位', value: item?.casePosition },
    { label: '法院名称', value: item?.courtName },
    { label: '立案时间', value: item?.caseRegTime },
    { label: '结案时间', value: item?.caseEndTime },
    { label: '案件状态', value: item?.caseStatus },
    { label: '案由', value: item?.caseReason },
    { label: '判决结果', value: item?.caseResult },
  ].filter((field) => field.value || field.value === 0 || field.value === '0')

  return (
    <div
      className="rounded-lg border px-4 py-4"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Stack gap="sm">
        <Text size="xs" c="dimmed">
          案件 {number}
        </Text>
        <div className="grid gap-3 md:grid-cols-2">
          {fields.map((field) => (
            <div key={field.label} className="flex flex-col gap-1">
              <Text size="xs" c="dimmed">
                {field.label}
              </Text>
              <Text size="sm" className="text-gray-700" fw={500}>
                {field.value || '—'}
              </Text>
            </div>
          ))}
        </div>
      </Stack>
    </div>
  )
}
